import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  let noAuth = false;
  let admin = false;

  to.matched.some((record) => {
    if (record.meta.noAuth) noAuth = record.meta.noAuth;
  });

  to.matched.some((record) => {
    if (record.meta.admin) admin = record.meta.admin;
  });

  if (admin && localStorage.getItem("isAdmin") != "true")
    next({
      path: "/dashboard",
    });

  if (noAuth == true) {
    next();
  } else {
    if (localStorage.getItem("access_token") == null) {
      next({
        path: "/login",
        query: { nextUrl: to.fullPath },
      });
    } else {
      next();
    }
  }
});

export default router;
